import EmptyStatus from '../empty-status'
import { Box, HStack } from '@chakra-ui/react'
import { useQueryState } from 'nuqs'
import { SimpleGrid, VStack } from '@chakra-ui/react'
import OrderCard from '../order-card'
import { ISingleOrder } from '@/_service/types/orders'
import {
  PaginationItems,
  PaginationNextTrigger,
  PaginationPrevTrigger,
  PaginationRoot,
} from '@/components/ui/pagination'
import Preview from '../../_components/Preview'

export default function OrderList({
  isLoading,
  ordersData,
}: {
  isLoading: boolean
  ordersData:
    | {
        orders: ISingleOrder[]
        count: number | string
      }
    | undefined
}) {
  const [page, setPage] = useQueryState('page')
  const [id, setId] = useQueryState('id')

  const handleOrderClick = (order: ISingleOrder) => {
    if (!order?.id) return
    setId(order?.id)
  }

  if (!isLoading && ordersData?.count == 0) {
    return <EmptyStatus />
  } else
    return (
      <SimpleGrid w='full' columns={{ base: 1, md: 2 }} columnGap={7}>
        <VStack mb={'90px'} gap={4} alignItems='stretch'>
          {ordersData?.orders?.map((order) => (
            <OrderCard
              key={order.id}
              order={order}
              onClick={handleOrderClick}
            />
          ))}

          {Number(ordersData?.count) > 20 && (
            <PaginationRoot
              mt={4}
              pageSize={20}
              defaultPage={1}
              page={Number(page) || 1}
              count={Number(ordersData?.count)}
              onPageChange={(e) => setPage(`${e.page}`)}
            >
              <HStack>
                <PaginationPrevTrigger />
                <PaginationItems />
                <PaginationNextTrigger />
              </HStack>
            </PaginationRoot>
          )}
        </VStack>

        <Box>{id && <Preview id={id} shipperId={''} />}</Box>
      </SimpleGrid>
    )
}
